import React, { useContext } from 'react';
import { DetailContext } from '@eas/common-web';
import { usePlenaryOpinionPermission } from '../../../es-file/es-file-permission';
import { IndexesFields as Indexes } from '../../../es-file/fields/indexes/indexes';

export function IndexesFields() {
  const { source } = useContext(DetailContext);
  const { hasPermission } = usePlenaryOpinionPermission(source.data);

  return (
    <>
      <Indexes hasPermission={hasPermission} />
    </>
  );
}
